import { RightOutlined } from '@ant-design/icons';
import { ILast14DaysActivity } from '@sdk/contracts';
import { Collapse, Empty } from 'antd';
import { useState } from 'react';

import { ActivityItem } from './ActivityItem/ActivityItem';
import {
  ActivitiesWrapper,
  CollapseHeaderWrapper,
  CollapseWrapper,
  EmptyWrapper
} from './SectionList.styles';

type Props = {
  sections?: Record<string, ILast14DaysActivity[]>;
};

export const SectionList: React.FC<Props> = ({ sections }) => {
  const [currentSectionId, setCurrentSectionId] = useState<string | undefined>(undefined);

  if (!sections) return null;

  const isEmpty = Object.values(sections).every(section => section.length === 0);

  if (isEmpty)
    return (
      <EmptyWrapper>
        <Empty />
      </EmptyWrapper>
    );

  return (
    <CollapseWrapper>
      {Object.entries(sections).map(([sectionId, activityTracks]) => (
        <Collapse
          key={sectionId}
          accordion
          activeKey={currentSectionId}
          onChange={key => setCurrentSectionId(key[0])}
          expandIcon={({ isActive }) => <RightOutlined rotate={isActive ? 90 : 0} />}>
          <Collapse.Panel
            header={<CollapseHeaderWrapper>{activityTracks[0].section.name}</CollapseHeaderWrapper>}
            key={sectionId}>
            <ActivitiesWrapper>
              {activityTracks.map(track => (
                <ActivityItem key={track.activity._id} activityTrack={track} />
              ))}
            </ActivitiesWrapper>
          </Collapse.Panel>
        </Collapse>
      ))}
    </CollapseWrapper>
  );
};
